/**
 * Responsive breakpoint definitions for the design system.
 *
 * Derived from the Figma "Responsive / Typography" variable collection,
 * which has three modes: Common, Mobile, Desktop.
 * Common and Desktop share identical values; Mobile scales down.
 *
 * Usage (CSS):
 *   @media (max-width: 767px) { ... }   // Mobile
 *   @media (min-width: 768px) { ... }    // Desktop
 *
 * Usage (JS):
 *   import { breakpoints } from '@xsolla/xui-core';
 *   const isMobile = window.innerWidth < breakpoints.desktop;
 */

export const breakpoints = {
  /** Mobile: 0 – 767px */
  mobile: 0,
  /** Desktop: 768px and above */
  desktop: 768,
} as const;

export type BreakpointKey = keyof typeof breakpoints;

/**
 * Max-width media query value for targeting mobile devices.
 * Use in CSS: `@media (max-width: ${MOBILE_MAX_WIDTH}px)`
 */
export const MOBILE_MAX_WIDTH = breakpoints.desktop - 1;
